import { EstimatedTradeCostApiResponse } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiResponse';
import isNil from 'lodash/isNil';

export type ValidateResponse = {
    isValid: boolean;
    error?: { message: string; data: unknown };
};
const fail: (message: string, data?: unknown) => ValidateResponse = (
    message,
    data
) => ({
    isValid: false,
    error: { message, data },
});

export function validateResponse(
    response: EstimatedTradeCostApiResponse
): ValidateResponse {
    if (!(response.status ?? '').startsWith('SUCCESS')) {
        const suffix = response.message ? ` (${response.message})` : '';
        return fail(
            `Response status is "${response.status}"${suffix}`,
            response.errors
        );
    }

    if (!response.results) {
        return fail('No "results" in request');
    }
    if (response.results.length !== 1) {
        return fail(
            `Unexpected number of results (${response.results.length}) in response (expected 1)`
        );
    }
    if (!response.results[0].summary) {
        if (response.results[0].message) {
            return fail(response.results[0].message);
        }
        return fail('No "summary" in result');
    }
    if (isNil(response.results[0].summary.bm_cost)) {
        return fail('No "bm_cost" in result summary');
    }
    if (isNil(response.results[0].summary.current_risk)) {
        return fail('No "current_risk" in result summary');
    }

    return { isValid: true };
}
